import { devLog } from './devLogger';

/**
 * Read-only fields (matches 1.0 readonly.js)
 * These fields are disabled for editing (usually pre-filled from partner system)
 */
export const READ_ONLY_FIELDS = [
  //Malaysia Taxonomy
      // Filing Information
      'ssmt-dei:DisclosureOfFinancialStatementsPreparationForCurrentSubmission',
      'ssmt-dei:CompanyCurrentFinancialYearStartDate',
      'ssmt-dei:CompanyCurrentFinancialYearEndDate',
      'ssmt-dei:CompanyPreviousFinancialYearStartDate',
      'ssmt-dei:CompanyPreviousFinancialYearEndDate',
      'ssmt-dei:BasisOfAccountingStandardsAppliedToPrepareFinancialStatements',
      'ssmt-dei:TypeOfSubmission',
      'ssmt-dei-ee-mpers:NatureOfFinancialStatements',
      'ssmt-dei:DescriptionOfPresentationCurrency',
      'ssmt-dei:NameAndVersionOfSoftwareUsedToGenerateXBRLFile',
      'ssmt-dei:TaxonomyVersion',
      
      // Scope of Filing
      'ssmt:MethodUsedForPreparingStatementOfFinancialPosition',
      'ssmt:MethodUsedForPreparingStatementOfProfitOrLoss',
      'ssmt:MethodUsedForPreparingStatementOfComprehensiveIncome',
      'ssmt:MethodUsedForRepresentingChangesInAnEntitysEquity',
      'ssmt:MethodUsedForPreparingStatementOfCashFlows',

      // CLBS 1965
      'ssmt-dei-1965:DisclosureOfFinancialStatementsPreparationForCurrentSubmission',
      'ssmt-dei-1965:CompanyCurrentFinancialYearStartDate',
      'ssmt-dei-1965:CompanyCurrentFinancialYearEndDate',
      'ssmt-dei-1965:CompanyPreviousFinancialYearStartDate',
      'ssmt-dei-1965:CompanyPreviousFinancialYearEndDate',
      'ssmt-dei-1965:NatureOfFinancialStatements',
      'ssmt-dei-1965:MethodUsedForPreparingStatementsOfFinancialPosition',
      'ssmt-dei-1965:DescriptionOfPresentationCurrency',
      'ssmt-dei-1965:NameAndVersionOfSoftwareUsedToGenerateXBRLFile',
      'ssmt-dei-1965:TaxonomyVersion',
      'ssmt-dei-1965:TypeOfSubmission',
      'ssmt-dei-1965:FinancialYear',

  // Singapore Taxonomy
      'sg-dei:CurrentPeriodStartDate',
      'sg-dei:CurrentPeriodEndDate',
      'sg-dei:PriorPeriodStartDate',
      'sg-dei:TaxonomyVersion',
      'sg-dei:TypeOfXBRLFiling',
      'sg-dei:TypeOfStatementOfFinancialPosition',
      'sg-dei:DescriptionOfPresentationCurrency',
      'sg-dei:NameAndVersionOfSoftwareUsedToGenerateInstanceDocument',
      'sg-dei:NatureOfFinancialStatementsCompanyLevelOrConsolidated',
];

/**
 * Check if a field should be read-only
 */
export const isReadOnlyField = (qname: string): boolean => {
  return READ_ONLY_FIELDS.includes(qname);
};

/**
 * Apply read-only attribute to fields
 */
export const applyReadOnlyFields = () => {
  READ_ONLY_FIELDS.forEach(qname => {
    const inputs = document.querySelectorAll(`input[data-qname="${qname}"], select[data-qname="${qname}"], textarea[data-qname="${qname}"]`);
    inputs.forEach(element => {
      if (element instanceof HTMLSelectElement) {
        // For selects: Use pointer-events to prevent interaction but keep value for saving
        element.style.pointerEvents = 'none';
        element.style.backgroundColor = '#f5f5f5';
        element.style.color = '#6c757d';
        element.style.cursor = 'not-allowed';
        // Add a visual indicator
        element.setAttribute('data-readonly', 'true');
      } else if (element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement) {
        // For inputs/textareas: Use readOnly (NOT disabled) so value is still saved
        element.readOnly = true;
        element.style.backgroundColor = '#f5f5f5';
        element.style.color = '#6c757d';
        element.style.cursor = 'not-allowed';
        element.setAttribute('data-readonly', 'true');
      }
    });
  });
  devLog('✅ Applied read-only to', READ_ONLY_FIELDS.length, 'fields');
};

